import * as Sentry from '@sentry/vue'
import SurveyMutations from '@/vuex/mutations/survey'
import SurveyGetters from '@/vuex/getters/survey'
import store from '@/vuex/store'
import SurveyApi from '@/api/survey'
import PresentationSessionApi from '@/api/presentationSession'

let uniqueSurveyId = null
const { isBackstage } = store.state
const PRESENTING_EXPERIENCE_SURVEY_CODE = 'PRESENTING'
const DELAY_TIME = 500

const initActiveSurveyData = async () => {
  try {
    const res = await SurveyApi.getActiveSurveysForPresenter()
    if (!res) return
    SurveyMutations.setActiveSurveys(store.state, res.surveys)
    // Script to identify crazy egg user
    const surveyScript = document.createElement('script')
    surveyScript.type = 'text/javascript'
    surveyScript.innerHTML = `
      if (window.CE2) {
        CE2.identify('${store.state.currentUser.id}'); 
      } else {
        window.CE_READY = function() {
          CE2.identify('${store.state.currentUser.id}');
        } 
      }
    `
    document.head.appendChild(surveyScript)
  } catch (error) {
    Sentry.captureException(error)
  }
}

const isWildcardMatch = (pattern, path) => {
  const patternParts = pattern.split('/')
  const pathParts = path.split('/')
  let result = false
  for (let i = 0; i < patternParts.length; i++) {
    if (patternParts[i] === '*' && patternParts[i - 1] == pathParts[i - 1]) {
      result = true
      break
    }
    if (patternParts[i] !== pathParts[i]) {
      result = false
    }
  }
  return result
}

const getSurveysForPath = (path) => {
  const results = []
  const surveys = SurveyGetters.getActiveSurveys(store.state)
  for (let i = 0; i < surveys.length; i++) {
    const survey = surveys[i]
    for (let j = 0; j < survey.targetPages.length; j++) {
      const targetPage = survey.targetPages[j]
      if (targetPage === path || isWildcardMatch(targetPage, path)) {
        results.push(survey)
        break
      }
    }
  }
  return results
}

const delay = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const removeSurveyScriptIfExisted = async (surveyId) => {
  if (!surveyId) {
    surveyId = uniqueSurveyId
  }
  await delay(DELAY_TIME)
  const scriptId = `survey-script-${surveyId}`
  const existingScript = document.getElementById(scriptId)
  if (!existingScript) return
  existingScript.remove()
}

const addSurveyTriggerScript = async (surveyId, delayTime) => {
  await delay(delayTime)
  const surveyScript = document.createElement('script')
  surveyScript.type = 'text/javascript'
  surveyScript.id = `survey-script-${surveyId}`
  surveyScript.innerHTML = `
    (window.CE_API || (window.CE_API=[])).push(function(){
        CE2.showSurvey("${surveyId}");
    });
  `
  document.head.appendChild(surveyScript)
}

const handleTriggerScript = async (surveyId, survey) => {
  await removeSurveyScriptIfExisted(surveyId)
  const delayTime = ((survey.delayTime && survey.delayTime > 0) ? survey.delayTime : 0) * 1000
  addSurveyTriggerScript(surveyId, delayTime)
  if (survey.surveyCode == PRESENTING_EXPERIENCE_SURVEY_CODE) {
    PresentationSessionApi.triggerSurveyForAllSessionOfUser() // only display survey once in a user's session
  }
}

const checkToShowSurveyOnAPage = async (path) => {
  try {
    const activeSurveysOnCurrentPage = getSurveysForPath(path)
    if (!activeSurveysOnCurrentPage) return
    for (let i = 0; i < activeSurveysOnCurrentPage.length; i++) {
      const survey = activeSurveysOnCurrentPage[i]
      // eslint-disable-next-line no-await-in-loop
      const res = await SurveyApi.getSurvey(survey.surveyCode)
      if (res.surveyId && !isBackstage) {
        handleTriggerScript(res.surveyId, survey)
        uniqueSurveyId = res.surveyId
        break
      }
    }
  } catch (error) {
    Sentry.captureException(error)
  }
}

const addStyleDisplayNoneToSurvey = async () => {
  await delay(DELAY_TIME)
  const surveyElements = document.querySelectorAll('crazyegg-survey')
  if (!surveyElements) return
  surveyElements.forEach((surveyElement) => {
    surveyElement.style.display = 'none'
  })
}

const removeStyleDisplayNoneToSurvey = async () => {
  await delay(DELAY_TIME)
  const surveyElements = document.querySelectorAll('crazyegg-survey')
  if (!surveyElements) return
  surveyElements.forEach((surveyElement) => {
    surveyElement.style.display = ''
  })
}

export default {
  initActiveSurveyData,
  checkToShowSurveyOnAPage,
  addSurveyTriggerScript,
  removeSurveyScriptIfExisted,
  addStyleDisplayNoneToSurvey,
  removeStyleDisplayNoneToSurvey,
}
